import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    marginTop: theme.spacing(1),
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOptions/components/BidPage/useStyles.js